import { Req, getUrlParams, formatNum } from  './../util/util';
import { getDanaOrderDetail } from  './danaIndex';
let orderNum = getUrlParams('orderNum');
if(!orderNum) alert("Test Nomor perintah hilang");

$(()=>{
  var layer = layui.layer;
  layui.use(['layer'], function () {
      layer = layui.layer;
  });
  var loading;
    let bankList = ['BCA','M1','BT','B1','I1','VA','BRI','I2','BNC','VC'];
    let walletList = ['OV', 'DANA', 'QRIS'];
    let storeList = ['FT', 'DT'];
    const methodsNames = {
        BCA:'BCA',
        'BCA-BANK':'BCA',
        BNC:'BANK NEO COMMERCE',
        BSI:'BSI',
        OCBC:'OCBC',
        M1:'Mandiri',
        BT:"Permata",
        B1:"CIMB",
        I1:"BNI",
        'BNI-BANK':"BNI",
        VA:"Maybank",
        BRI:"BRI",
        I2:"Danamon",
        OV: "OVO",
        DANA: "DANA",
        FT: "ALFAMART",
        DT: "INDOMART",
        GOPAY: "GoPay",
        SHOPEEPAY: "ShopeePay",
        AKULAKU: "Akulaku",
        QRIS: "EWallet Scan",
        'BCA-VA':'BCA',
        A1:'ATM Bersama',
        'FT-VA': 'ALFAMART',
        SASP:'Sahabat Sampoerna',
        BSIS:'BSI Syariah',
        LINKAJA:'LINKAJA',
        'FAS-OVO': "OVO",
        VC:"Credit Card"
    }

    getData();
    expandMenu();

    //获取订单数据
    function getData(){
        if(!orderNum) return ;
        Req({
            url: "/gateway/getPayMethod/v2",
            type: "POST",
            data: JSON.stringify({
                orderNum
            })
        }, res=>{
            let {
                walletMethod=[], storeMethod=[],
                bankMethod=[], vaMethod=[],
                customerName, payMoney,
                name, redirectUrl, onMethod, jumpUrl
            } = res.data || {};

            // if("" != onMethod){
            //     window.location.href = './html/'+ onMethod +'.html?type='+ onMethod +'&orderNum=' + orderNum;
            // }

            if(!jumpUrl){
                // console.log("11");
            }else {
                // console.log("22");
                window.location.href = jumpUrl;
                return;
            }

            $(".total-number .number").html(formatNum(payMoney));
            $(".card-footer-info .no").html(orderNum);
            $(".card-footer-info .barang").html(customerName);

            //va 列表渲染
            if(vaMethod && vaMethod.length){
                let bankListHtml = '';
                vaMethod.forEach((item, index)=>{
                    bankListHtml += `
                    <a class="${item}" href="./html/${ item }.html?type=${item}&orderNum=${ orderNum || "" }">
                        <div class="item">
                            <div class="item-content">
                                <img src="./img/bank/${ item }.png" style="width: 42px;height: 29px;" alt="">
                                <div>${ methodsNames[item] }</div>
                            </div>
                            ${ index < (bankMethod.length - 2) ? '<div class="halfpxline"></div>' : "" }
                        </div>
                    </a>
                `;
                });
                $(".list-container .va .menu-items").html(bankListHtml);
            }else{
                $(".list-container .va").remove();
            }

            //bank 列表渲染
            if(bankMethod && bankMethod.length){
                let bankListHtml = '';
                bankMethod.forEach((item, index)=>{
                    bankListHtml += `
                    <a class="${item}" href="./html/${ item }.html?type=${item}&orderNum=${ orderNum || "" }">
                        <div class="item">
                            <div class="item-content">
                                <img src="./img/bank/${ item }.png" style="width: 42px;height: 29px;" alt="">
                                <div>${ methodsNames[item] }</div>
                            </div>
                            ${ index < (bankMethod.length - 2) ? '<div class="halfpxline"></div>' : "" }
                        </div>
                    </a>
                `;
                });
                $(".list-container .bank .menu-items").html(bankListHtml);
            }else{
                $(".list-container .bank").remove();
            }

            //wallet 列表渲染
            if(walletMethod && walletMethod.length){
                let walletListHtml = '';
                walletMethod.forEach((item, index)=>{
                  if(item=="DANA"){
                    walletListHtml += `
                        <div class="item" id="${ item }">
                            <div class="item-content">
                                <img src="./img/wallet/${ item }.png" style="width: 42px;height: 29px;" alt="">
                                <div>${ methodsNames[item] }</div>
                            </div>
                            ${ index < (walletMethod.length - 2) ? '<div class="halfpxline"></div>' : "" }
                        </div>
                `;
                  }else{
                    walletListHtml += `
                  <a href="./html/${ item }.html?type=${ item }&orderNum=${ orderNum || "" }&number=${ payMoney }&redirectUrl=${ redirectUrl }">
                      <div class="item">
                          <div class="item-content">
                              <img src="./img/wallet/${ item }.png" style="width: 42px;height: 29px;" alt="">
                              <div>${ methodsNames[item] }</div>
                          </div>
                          ${ index < (walletMethod.length - 2) ? '<div class="halfpxline"></div>' : "" }
                      </div>
                  </a>
              `;}
                });
                $(".list-container .wallet .menu-items").html(walletListHtml);
            }else{
                $(".list-container .wallet").remove();
            }

            //store 列表渲染
            if(storeMethod && storeMethod.length){
                let storeListHtml = '';
                storeMethod.forEach((item, index)=>{
                    storeListHtml += `
                    <a href="./html/${item}.html?type=${item}&orderNum=${ orderNum || "" }">
                        <div class="item">
                            <div class="item-content">
                                <img src="./img/store/${item}.png" style="width: 42px;height: 29px;" alt="">
                                <div>${ methodsNames[item] }</div>
                            </div>
                            ${ index < (storeMethod.length - 2) ? '<div class="halfpxline"></div>' : "" }
                        </div>
                    </a>
                `;
                });
                $(".list-container .store .menu-items").html(storeListHtml);
            }else{
                $(".list-container .store").remove();
            }

            $('.back-to-last').click(e => {
                location.href = redirectUrl;
                return false;
            });
            $('#DANA').click(e => {
              showLoading();
              getDanaOrderDetail();
              // hideLoading();
          });
            
        }, error=>{
            console.log(error)
        })
    }
    function showLoading() {
      loading = layer.load(0, {
          shade: false,
      });
    }

    function hideLoading() {
      layer.close(loading);
  }
    //绑定展开菜单的事件
    function expandMenu(){
        $('.list-container .menu').click(function(){
            $('.list-container .menu.active').removeClass('active')
            $(this).addClass("active");
        });
    }
});
